export default __webpack_public_path__ + "static/media/Standard49.fd5f92ee.png";